import { Serializer, Serializers, SerializerValue } from "@megaron/serializers";

export type Row = Record<string, unknown>;

export const syncOperationSerializer = <T extends Row>(propsSerializer: {
  [key in keyof T]: Serializer<T[key]>;
}) =>
  Serializers.object({
    id: Serializers.string,
    action: Serializers.stringOneOf("update", "create", "delete"),
    properties: Serializers.object<T>(propsSerializer).partial(),
    existing: Serializers.object<T>(propsSerializer).optional(),
  });

export type SyncOperation<T extends Row> = SerializerValue<ReturnType<typeof syncOperationSerializer<T>>>;

export const syncErrorSerializer = Serializers.object({
  ...Serializers.object({
    id: Serializers.string.optional(),
    field: Serializers.string.optional(),
    value: Serializers.string.optional(),
  }).partial().fields,
  message: Serializers.string,
});

export type SyncError = SerializerValue<typeof syncErrorSerializer>;

export const syncResultSerializer = <T extends Row>(propsSerializer: {
  [key in keyof T]: Serializer<T[key]>;
}) =>
  Serializers.object({
    operations: syncOperationSerializer(propsSerializer).array(),
    errors: syncErrorSerializer.array(),
  });

export type SyncResult<T extends Row> = SerializerValue<ReturnType<typeof syncResultSerializer<T>>>;

export const mergeSyncResults = <T extends Row>(a: SyncResult<T>, b: SyncResult<T>): SyncResult<T> => ({
  operations: [...a.operations, ...b.operations],
  errors: [...a.errors, ...b.errors],
});
